import * as types from 'store/actions/types';
import services from 'services/services';
import { checkErrorStatus } from 'store/helpers/error_status';
import { getErrorCodeResults } from 'helpers/error_code_api';
import i18next from 'i18next';
import { openNotification } from 'components/utilities/notification/notification';

export const fetchNpvrRecordings = () => async (dispatch) => {
	try {
		// Dispatch an loading action
		dispatch({
			type: types.FETCH_NPVR_RECORDINGS_LOADING,
			payload: true
		});

		const { data } = await services.get('/recordings/npvr');

		// Dispatch an success action
		dispatch({
			type: types.FETCH_NPVR_RECORDINGS_SUCCESS,
			payload: data
		});
	} catch {
		// Dispatch an error action
		dispatch({
			type: types.FETCH_NPVR_RECORDINGS_ERROR,
			payload: true
		});
	}
};

export const removeNpvrRecordingsItem = (
	recordingId,
	callbackSuccess
) => async (dispatch) => {
	try {
		// Dispatch an loading action
		dispatch({
			type: types.REMOVE_NPVR_RECORDINGS_ITEM_LOADING,
			payload: true
		});

		await services.delete(`/recordings/npvr/${recordingId}`);

		// Dispatch an action
		dispatch({
			type: types.REMOVE_NPVR_RECORDINGS_ITEM_SUCCESS,
			payload: recordingId
		});

		callbackSuccess();
	} catch (error) {
		if (error.response) {
			const { codeErrorMessage } = getErrorCodeResults(error);

			error.response.data.message = codeErrorMessage;
			// Dispatch an error action
			dispatch({
				type: types.REMOVE_NPVR_RECORDINGS_ITEM_ERROR,
				payload: error.response.data.message
			});

			checkErrorStatus(error) &&
				openNotification({
					type: 'error',
					title: i18next.t('common_recordings_error_title'),
					description:
						codeErrorMessage || i18next.t('common_recordings_error_description')
				});
		}
	}
};

export const clearNpvrRecordingsErrors = () => (dispatch) => {
	// Dispatch an loading action
	dispatch({
		type: types.CLEAR_NPVR_RECORDINGS_ERRORS,
		payload: true
	});
};

export const scheduleNpvrRecording = (program_uuid, callback) => async (
	dispatch
) => {
	try {
		dispatch({
			type: types.SCHEDULE_NPVR_RECORDING_LOADING,
			payload: true
		});

		openNotification({
			type: 'success',
			title: i18next.t('recordings_title_schedule'),
			description: i18next.t('recordings_desc_schedule')
		});

		const payload = {
			program_uuid,
			type: 'npvr'
		};

		await services.post('/recordings/npvr/create', payload);

		// Dispatch an action
		dispatch({
			type: types.SCHEDULE_NPVR_RECORDING_SUCCESS,
			payload: true
		});

		callback();
		openNotification({
			type: 'success',
			title: i18next.t('recordings_title_success'),
			description: i18next.t('recordings_desc_success')
		});
	} catch (error) {
		dispatch({
			type: types.SCHEDULE_NPVR_RECORDING_ERROR,
			payload: true
		});

		if (error.response) {
			const { codeErrorMessage } = getErrorCodeResults(error);

			checkErrorStatus(error) &&
				openNotification({
					type: 'error',
					title: i18next.t('recordings_title_error'),
					description: codeErrorMessage || i18next.t('recordings_desc_error')
				});
		}
	}
};
